var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83493 7.1685L12.8469 9.44843L8.83493 11.7284V7.1685ZM19.8426 2.02286V16.8571C19.8426 17.9739 18.9366 18.88 17.8198 18.88H2.9855C1.86872 18.88 0.962646 17.9739 0.962646 16.8571V2.02286C0.962646 0.906071 1.86872 0 2.9855 0H17.8198C18.9366 0 19.8426 0.906071 19.8426 2.02286ZM18.0726 9.45264C18.0726 9.45264 18.0726 6.94093 17.7524 5.73564C17.5754 5.06979 17.057 4.54721 16.3954 4.37021C15.2027 4.04571 10.4026 4.04571 10.4026 4.04571C10.4026 4.04571 5.60258 4.04571 4.40993 4.37021C3.74829 4.54721 3.22993 5.06979 3.05293 5.73564C2.73265 6.93671 2.73265 9.45264 2.73265 9.45264C2.73265 9.45264 2.73265 11.9644 3.05293 13.1696C3.22993 13.8355 3.74829 14.337 4.40993 14.514C5.60258 14.8343 10.4026 14.8343 10.4026 14.8343C10.4026 14.8343 15.2027 14.8343 16.3954 14.5098C17.057 14.3328 17.5754 13.8313 17.7524 13.1654C18.0726 11.9644 18.0726 9.45264 18.0726 9.45264Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.906a843180980d2ed41141150a89757d.svg";
export { ForwardRef as ReactComponent };